import { prop, propEq } from 'rambda'
import { factory } from '@store/utils'

export default {
  auto: '*',

  store: {
    state: {
      laptopsQueries: [
        {
          type: 'missing',
          key: 'memoryAmountNullish',
          label: 'Memory amount',
          query: [{ memoryAmount: null }],
        },
        {
          type: 'missing',
          key: 'ssdHddAmountNullish',
          label: 'Storage',
          query: [{ ssdAmount: 0, hddAmount: 0 }],
        },
        {
          type: 'missing',
          key: 'priceNullish',
          label: 'Price',
          query: [{ price: null }],
        },
        {
          type: 'missing',
          key: 'gpuNullish',
          label: 'GPU',
          query: [{ gpu: null }],
        },
        {
          type: 'missing',
          key: 'cpuNullish',
          label: 'CPU',
          query: [{ cpu: null }],
        },
        // {
        //   type: 'missing',
        //   key: 'portsNullish',
        //   label: 'Ports',
        //   query: [{
        //     portsUsb2: 0,
        //     portsUsb3a: 0,
        //     portsUsb3c: 0,
        //     portsDisplayPort: 0,
        //     portsThunderbolt: 0,
        //     portsHdmi: 0,
        //   }],
        // },
        {
          type: 'missing',
          key: 'weightNullish',
          label: 'Weight',
          query: [
            { weight: null },
          ],
        },
        {
          type: 'improper',
          key: 'memoryAmountLow',
          label: 'Memory amount',
          query: [
            { price: { $gt: 350 }, memoryAmount: { $lt: 4 } },
            { price: { $gt: 1000 }, memoryAmount: 6 },
            { ssdAmount: { $gt: 256 }, memoryAmount: { $lt: 4 } },
          ],
        },
        {
          type: 'improper',
          key: 'ssdHddAmountLow',
          label: 'Storage',
          query: [
            { price: { $gt: 350 }, ssdAmount: { $lt: 32 }, hddAmount: { $lt: 256 } },
            { price: { $gt: 900 }, ssdAmount: { $lt: 256 }, hddAmount: { $lt: 500 } },
          ],
        },
        {
          type: 'improper',
          key: 'weightSmall',
          label: 'Weight',
          query: [
            { weight: { $lt: 0.5 } },
          ],
        },
      ],
    },
    getters: {
      laptopFactory: factory(() => ({
        name: null,
      })),

      linksExternalFactory: factory(() => ({
        label: null,
        type: 'BUY',
        price: null,
        updatedAt: new Date().toISOString(),
        url: null,
      })),
      linksExternalTypeOptions: () => [
        { label: 'BUY', value: 'BUY' },
        { label: 'SPECS', value: 'SPECS' },
        { label: 'ETC', value: 'ETC' },
      ],

      laptopReviewExternalFactory: factory(() => ({
        id: null,
        authorName: null,
        cons: [],
        laptop: {},
        lastCrawledAt: null,
        matchScore: null,
        pros: [],
        reviewedAt: null,
        scoreOriginal: null,
        scorePercent: null,
        siteName: null,
        summary: null,
        title: null,
        url: null,
      })),

      formAmazonLink: () => asin => `https://www.amazon.com/dp/${asin}`,

      laptopsQueries: prop('laptopsQueries'),
      laptopsQueriesOptions: ({ laptopsQueries }) => {
        const options = laptopsQueries
          .map(({ key, label, type }) => ({ value: key, label, type }))

        return {
          missing: options
            .filter(propEq('type', 'missing')),
          improper: options
            .filter(propEq('type', 'improper')),
        }
      },
    },
  },
}
